import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, Wrench } from "lucide-react";

export default function Mechanics() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", phone: "", specialty: "", active: true });

  const load = async () => setItems((await api.get("/mechanics")).data);
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm({ name: "", phone: "", specialty: "", active: true }); setOpen(true); };
  const openEdit = (m) => { setEditing(m); setForm({ name: m.name, phone: m.phone || "", specialty: m.specialty || "", active: !!m.active }); setOpen(true); };

  const save = async () => {
    if (!form.name.trim()) return toast.error("İsim gerekli");
    try {
      if (editing) {
        await api.put(`/mechanics/${editing.id}`, form);
        toast.success("Güncellendi");
      } else {
        await api.post("/mechanics", form);
        toast.success("Eklendi");
      }
      setOpen(false); load();
    } catch (e) { toast.error("Hata oluştu"); }
  };

  const del = async (id) => {
    if (!confirm("Silmek istediğinize emin misiniz?")) return;
    await api.delete(`/mechanics/${id}`);
    toast.success("Silindi"); load();
  };

  return (
    <div className="space-y-6" data-testid="mechanics-page">
      <div className="flex items-baseline justify-between flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-slate-500 font-mono">Kadro</div>
          <h1 className="mt-1 font-heading font-bold text-3xl lg:text-4xl tracking-tight text-slate-900">Ustalar</h1>
        </div>
        <Button onClick={openNew} data-testid="add-mechanic-btn" className="bg-[#1E3A8A] hover:bg-[#1e40af]">
          <Plus className="w-4 h-4 mr-2" /> Yeni Usta
        </Button>
      </div>

      <Card className="border-slate-200 shadow-none">
        <CardContent className="pt-6">
          <div className="overflow-x-auto rounded-md border border-slate-200">
            <Table>
              <TableHeader>
                <TableRow className="bg-slate-50 hover:bg-slate-50">
                  <TableHead className="text-xs uppercase tracking-wider">Ad Soyad</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider">Telefon</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider">Uzmanlık</TableHead>
                  <TableHead className="text-xs uppercase tracking-wider">Durum</TableHead>
                  <TableHead></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {items.map((m) => (
                  <TableRow key={m.id} className="hover:bg-slate-50">
                    <TableCell className="font-semibold flex items-center gap-2">
                      <div className="w-8 h-8 rounded-md bg-blue-50 text-[#1E3A8A] flex items-center justify-center">
                        <Wrench className="w-4 h-4" />
                      </div>
                      {m.name}
                    </TableCell>
                    <TableCell className="font-mono text-xs">{m.phone || "-"}</TableCell>
                    <TableCell>{m.specialty || "-"}</TableCell>
                    <TableCell>
                      {m.active
                        ? <span className="text-xs px-2 py-1 rounded bg-emerald-50 text-emerald-700 border border-emerald-200">Aktif</span>
                        : <span className="text-xs px-2 py-1 rounded bg-slate-100 text-slate-500 border border-slate-200">Pasif</span>}
                    </TableCell>
                    <TableCell className="text-right">
                      <Button size="sm" variant="ghost" onClick={() => openEdit(m)}><Pencil className="w-4 h-4" /></Button>
                      <Button size="sm" variant="ghost" onClick={() => del(m.id)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle className="font-heading">{editing ? "Usta Düzenle" : "Yeni Usta"}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider">Ad Soyad</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" data-testid="mechanic-name-input" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider">Telefon</Label>
              <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider">Uzmanlık</Label>
              <Input value={form.specialty} onChange={(e) => setForm({ ...form, specialty: e.target.value })} className="mt-1" />
            </div>
            <div className="flex items-center justify-between border border-slate-200 rounded-md p-3">
              <span className="text-sm">Aktif</span>
              <Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} />
            </div>
            <Button onClick={save} data-testid="save-mechanic-btn" className="w-full bg-[#1E3A8A] hover:bg-[#1e40af]">
              {editing ? "Güncelle" : "Kaydet"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
